import type { SealedProduct, SealedCollectionItem } from '@/types'
import { request, buildQueryString } from './client'

export async function getAllSealedProducts(): Promise<{ sealedProducts: SealedProduct[]; updatedAt: string }> {
  return request<{ sealedProducts: SealedProduct[]; updatedAt: string }>('/sealed_products/all')
}

export async function getSealedProduct(id: number): Promise<{ sealedProduct: SealedProduct }> {
  return request(`/sealed_products/${id}`)
}

export async function addToSealedCollection(
  sealedProductId: number,
  quantity: number = 1,
  acquiredPrice?: number,
  notes?: string,
  idempotencyKey?: string,
): Promise<SealedCollectionItem> {
  const response = await request<{ sealedCollectionItem: SealedCollectionItem }>('/sealed_collection', {
    method: 'POST',
    body: {
      sealedProductId,
      quantity,
      acquiredPrice,
      notes,
    },
    idempotencyKey,
  })
  return response.sealedCollectionItem
}

export async function updateSealedCollectionItem(
  sealedProductId: number,
  updates: { quantity?: number; acquiredPrice?: number | null; notes?: string | null },
  idempotencyKey?: string,
): Promise<SealedCollectionItem> {
  const response = await request<{ sealedCollectionItem: SealedCollectionItem }>(
    `/sealed_collection/${sealedProductId}`,
    {
      method: 'PATCH',
      body: updates,
      idempotencyKey,
    },
  )
  return response.sealedCollectionItem
}

export async function removeFromSealedCollection(sealedProductId: number, idempotencyKey?: string): Promise<void> {
  await request<void>(`/sealed_collection/${sealedProductId}`, { method: 'DELETE', idempotencyKey })
}

export async function getSealedProductPrices(
  id: number,
  days: number = 30,
): Promise<{
  sealedProductId: number
  name: string
  prices: Array<{ marketPrice: number | null; recordedAt: string }>
}> {
  const query = buildQueryString({ days })
  return request(`/sealed_products/${id}/prices${query}`)
}
